import { Pill } from '@/shared/components/pill'
import {
  Dialog,
  DialogBody,
  DialogHeader,
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel
} from '@material-tailwind/react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLoaderData } from 'react-router-dom'
import { RequestContractChangeForm } from './forms/request-contract-change.form'
import { RequestContractTerminationForm } from './forms/request-contract-termination.form'
import { NotificationModal } from '@/components/notification-modal'

export const EmployeeRequests = () => {
  const { t } = useTranslation()
  const [currentEmployee, roles] = useLoaderData()
  const [, , { data }] = useLoaderData()

  const pillOptions = useMemo(() => {
    return [
      {
        label: t('common.firstName'),
        value: currentEmployee.fullName
      },

      {
        label: t('documentNumber.one'),
        value: currentEmployee.documentNumber
      },

      {
        label: t('contract.id'),
        value: String(currentEmployee?.activeContract?.contract?.id)
      }
    ]
  }, [currentEmployee])

  const TABS = Object.freeze({
    ContractChangeForm: 'contractChangeForm',
    ContractUnlinkForm: 'contractUnlinkForm'
  })

  return (
    <>
      {data.length > 0
        ? (
        <NotificationModal
          title={t('modal.modificationRequest.title')}
          message={t('modal.modificationRequest.message')}
          iconType='danger'
          returnPath='/employees/'
        />
          )
        : currentEmployee?.activeContract?.contract?.id === undefined
          ? (
        <NotificationModal
          title={t('modal.modificationRequestWithoutActiveContract.title')}
          message={t('modal.modificationRequestWithoutActiveContract.message')}
          iconType='danger'
          returnPath='/employees/'
        />
            )
          : (
        <Dialog open>
          <DialogHeader>Solicitud de modificación</DialogHeader>

          <DialogBody className='py-0'>
            <div className='flex gap-4 mb-4'>
              {pillOptions.map((pillOption) => (
                <Pill key={pillOption.value} {...pillOption} />
              ))}
            </div>
          </DialogBody>

          <DialogBody className='flex flex-col gap-4'>
            <Tabs value={TABS.ContractChangeForm}>
              <TabsHeader>
                <Tab value={TABS.ContractChangeForm}>Cambios contractuales</Tab>
                <Tab value={TABS.ContractUnlinkForm}>
                  Desvinculación del contrato
                </Tab>
              </TabsHeader>
              <TabsBody>
                <TabPanel value={TABS.ContractChangeForm} className='p-0 mt-4'>
                  <RequestContractChangeForm
                    currentEmployee={currentEmployee}
                    roles={roles}
                  />
                </TabPanel>
                <TabPanel value={TABS.ContractUnlinkForm} className='p-0 mt-4'>
                  <RequestContractTerminationForm
                    currentEmployee={currentEmployee}
                  />
                </TabPanel>
              </TabsBody>
            </Tabs>
          </DialogBody>
        </Dialog>
            )}
    </>
  )
}
